import React, { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import GreenSpinner from '../../../../Shared/Loading/GreenSpinner';

const AllArchiveGreen = ({postData}) => {

  
  const [AppliedData, setAppliedData] = useState([]);
  const [page, setPage] = useState(1);
  const [teacherEmail, setTeacherEmail] = useState(""); // State to store teacherEmail filter
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const fetchAppliedData = async () => {
    try {
      const response = await fetch(
        `https://tutor-tree-server-1.vercel.app/allTutorsReqGreen/archive/${postData.jobId}?page=${page}&limit=10&teacherEmail=${teacherEmail}`
      );
      const data = await response.json();
      setAppliedData(data.result);
      setTotalPages(data.pages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching AppliedData:", error);
    }
  };

  useEffect(() => {
    fetchAppliedData();
  }, [page, teacherEmail]); // Re-fetch data when page or teacherEmail changes

  if (loading) {
    return <GreenSpinner></GreenSpinner>;
  }
  return (
    <div className='bg-green-100 h-screen'>
      {/* Teacher Email Filter */}
      <input
        type="text"
        value={teacherEmail}
        onChange={(e) => setTeacherEmail(e.target.value)}
        placeholder="Filter by Teacher Email"
      />

      {/* Display Data */}
     <div className='grid grid-cols-4 gap-5 p-5'>
      {AppliedData.map(apply => 
        <div className='w-full h-56 bg-green-200 border border-green-500 rounded'  key={apply._id}>
              <div className='w-full h-10 bg-green-500 px-2 flex items-center justify-between'>
                 <h1 className='text-white font-montserrat'>{apply.applyingDate}</h1>
            </div>
             <div className='px-2 py-2'>
               <h1 className='text-lg font-montserrat'>Name : {apply.teacherName}</h1>
               <h1 className='text-sm font-montserrat'>Email : {apply.teacherEmail}</h1>
               <h1 className='text-sm font-montserrat'>Phone : {apply.phone}</h1>
               <h1 className='text-sm font-montserrat'>HSC Result : {apply.teacherHSCresult}</h1>
               <h1 className='text-sm font-montserrat'>HSC Group : {apply.teacherHSCgroup}</h1>
               <h1 className='text-sm font-montserrat'>Hons Institute : {apply.teacherHonsInstitute}</h1>
               <h1 className='text-sm font-montserrat'>Hons Major : {apply.teacherHonsMajor}</h1>
               <h1 className='text-sm font-montserrat'>Hons Semester : {apply.teacherHonsSemester}</h1>
             </div>
              <div></div>
        </div>
      )}
     </div>

      {/* Pagination Controls */}
      <div>
        <button onClick={() => setPage(page > 1 ? page - 1 : 1)} disabled={page === 1}>
          Previous
        </button>
        <span>Page {page} of {totalPages}</span>
        <button onClick={() => setPage(page < totalPages ? page + 1 : totalPages)} disabled={page === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
};

export default AllArchiveGreen;
